import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { QrcodeComponent } from './qrcode.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [QrcodeComponent],
  imports: [CommonModule, IonicModule, TranslateModule],
  exports: [QrcodeComponent]
})
export class QrcodeModule {}